"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Presentation = void 0;
var _jsxRuntime = require("react/jsx-runtime");
var Presentation = function Presentation() {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M26.55,38.97H14.3c-3.17,0-5.74-2.57-5.74-5.74V8.24c0-3.17,2.57-5.74,5.74-5.74H50.7\r c3.17,0,5.74,2.57,5.74,5.74v24.99c0,3.17-2.57,5.74-5.74,5.74H38.06"
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("line", {
          x1: "32.5",
          y1: "48.91",
          x2: "45.39",
          y2: "61.8"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("line", {
          x1: "32.5",
          y1: "48.91",
          x2: "19.61",
          y2: "61.8"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("line", {
          x1: "32.5",
          y1: "38.97",
          x2: "32.5",
          y2: "62.5"
        })]
      })]
    })
  });
};
exports.Presentation = Presentation;